(() => {
  const SHOP_ID = '2JGYqFiwH7yRtwUxhFs8p6';
  const PRODUCT_URL_PREFIX = 'https://jp.mercari.com/shops/product/';

  const validSnapshot = (value) => {
    if (!value || value.schema_version !== 1 || value.shop_id !== SHOP_ID) return false;
    if (typeof value.score !== 'number' || value.score < 0 || value.score > 5) return false;
    if (!Number.isInteger(value.rating_count) || value.rating_count < 1) return false;
    if (!value.verified_at || Number.isNaN(Date.parse(value.verified_at))) return false;
    if (!Array.isArray(value.reviews) || value.reviews.length < 1 || value.reviews.length > 3) return false;
    return value.reviews.every((review) => (
      review &&
      typeof review.comment === 'string' &&
      review.comment.trim().length > 0 &&
      review.comment.length <= 300 &&
      typeof review.url === 'string' &&
      review.url.startsWith(PRODUCT_URL_PREFIX)
    ));
  };

  const formatScore = (score) => Number.isInteger(score) ? String(score) : score.toFixed(1);

  const render = (section, snapshot) => {
    const english = section.dataset.locale === 'en';
    const score = formatScore(snapshot.score);
    const scoreNode = section.querySelector('[data-mercari-score]');
    const countNode = section.querySelector('[data-mercari-count]');
    const scoreBox = section.querySelector('[data-mercari-score-box]');
    if (scoreNode) scoreNode.textContent = `${score}/5`;
    if (countNode) {
      countNode.textContent = english
        ? `${snapshot.rating_count} public ratings`
        : `公開評価 ${snapshot.rating_count}件`;
    }
    if (scoreBox) {
      scoreBox.setAttribute(
        'aria-label',
        english
          ? `${score} out of 5 from ${snapshot.rating_count} ratings on Mercari Shops`
          : `メルカリShopsで${snapshot.rating_count}件の評価、5点満点中${score}点`,
      );
    }

    const cards = Array.from(section.querySelectorAll('[data-mercari-review]'));
    cards.forEach((card, index) => {
      const review = snapshot.reviews[index];
      if (!review) {
        card.hidden = true;
        return;
      }
      card.hidden = false;
      card.href = review.url;
      const quote = card.querySelector('[data-mercari-comment]');
      const meta = card.querySelector('[data-mercari-review-meta]');
      if (quote) {
        quote.textContent = `「${review.comment.trim()}」`;
        quote.lang = 'ja';
      }
      if (meta) {
        const label = english
          ? 'Public Mercari Shops buyer review'
          : 'メルカリShopsの公開購入者レビュー';
        meta.textContent = review.date ? `${review.date} · ${label}` : label;
      }
    });

    const verified = section.querySelector('[data-mercari-verified]');
    if (verified) {
      const date = new Intl.DateTimeFormat(english ? 'en-US' : 'ja-JP', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'Asia/Tokyo',
      }).format(new Date(snapshot.verified_at));
      verified.textContent = english
        ? `Automatically verified on ${date}. See Mercari for the live source.`
        : `${date}に自動確認済み。最新の公開情報はメルカリ上でご確認いただけます。`;
    }
  };

  document.querySelectorAll('[data-rf-mercari-trust]').forEach((section) => {
    const assetUrl = section.dataset.assetUrl;
    if (!assetUrl) return;
    fetch(assetUrl, { headers: { Accept: 'application/json' }, cache: 'no-cache' })
      .then((response) => {
        if (!response.ok) throw new Error(`Mercari trust asset HTTP ${response.status}`);
        return response.json();
      })
      .then((snapshot) => {
        if (validSnapshot(snapshot)) render(section, snapshot);
      })
      .catch(() => {
        // Intentional fail-soft behavior: Liquid's last verified fallback stays.
      });
  });
})();
